import type { ICalculateDraftOrder, IPaymentParam } from "../interface/draft-order";

const API_URL = {
  thisisneverthat: "https://47qqezisxqdm74ycuxv3wg5pkm0yxdgm.lambda-url.ap-northeast-2.on.aws/", // thisisneverthat_draft_order_calculate_intl
  yeseyesee: "https://jzh5o2q5fcau5vur3dt77ejlta0lklhj.lambda-url.ap-northeast-2.on.aws/", // yeseyesee_draft_order_calculate_intl
  khakis: "https://2qi3rumnsepqnp56foi2m5w4qm0wwxyt.lambda-url.ap-northeast-2.on.aws/", // khakis_draft_order_calculate_intl
  sunlove: "https://mvi4wfgtoymlaipxc2gwutjt2a0kouyw.lambda-url.ap-northeast-2.on.aws/", // sunlove_draft_order_calculate_intl
};

interface IProps {
  shop: string;
  param: IPaymentParam;
}

export default async function calculateDraftOrder({ shop, param }: IProps): Promise<ICalculateDraftOrder | undefined> {
  const lambdaUrl = API_URL[shop as keyof typeof API_URL];
  if (!lambdaUrl) return;

  try {
    const response = await fetch(lambdaUrl, { method: "POST", body: JSON.stringify(param) });
    const result = await response.json();
    if (response.ok && result.message === "Success") {
      return { message: "Success", data: result.data };
    }

    return { message: result.message };
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(`[LAMBDA][Calculate Draft Order] Failed to fetch : ${message}`);
  }
}
